import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "hamburger"]

  connect() {
    this.syncMenuTop = this.syncMenuTop.bind(this)
    this.syncMenuTop()
    window.addEventListener("resize", this.syncMenuTop)
  }

  disconnect() {
    window.removeEventListener("resize", this.syncMenuTop)
    document.body.style.overflow = ""
  }

  syncMenuTop() {
    const headerBar = this.element.firstElementChild
    if (headerBar && this.hasMenuTarget) {
      this.menuTarget.style.top = `${headerBar.offsetHeight}px`
    }
  }

  toggle() {
    this.syncMenuTop()
    this.menuTarget.classList.toggle("active")
    this.hamburgerTarget.classList.toggle("active")

    document.body.style.overflow = this.menuTarget.classList.contains("active") ? "hidden" : ""
  }

  close() {
    this.menuTarget.classList.remove("active")
    this.hamburgerTarget.classList.remove("active")
    document.body.style.overflow = ""
  }
}

